"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfiguration = {
    AssetTestLowerThresholdCoupleHomeowner: 470000,
    AssetTestLowerThresholdCoupleNonHomeowner: 722000,
    AssetTestUpperThresholdCoupleHomeowner: 1045500,
    AssetTestUpperThresholdCoupleNonHomeowner: 1297500,
    AssetTestLowerThresholdSingleHomeowner: 314000,
    AssetTestLowerThresholdSingleNonHomeowner: 566000,
    AssetTestUpperThresholdSingleHomeowner: 695500,
    AssetTestUpperThresholdSingleNonHomeowner: 947500,
    IncomeTestLowerThresholdCouple: 372,
    IncomeTestLowerThresholdSingle: 212,
    IncomeTestUpperThresholdCouple: 3822.4,
    IncomeTestUpperThresholdSingle: 2500.8,
    PensionCouple: 789.3,
    PensionSingle: 1047.1,
    PensionSupplementCoupleMaximum: 73.3,
    PensionSupplementCoupleMinimum: 44.4,
    PensionSupplementSingleMaximum: 97.3,
    PensionSupplementSingleMinimum: 58.9,
    DeemingThresholdSingle: 62600,
    DeemingThresholdCouple: 103800,
    DeemingRateLowerIncome: 0.0025,
    DeemingRateHigherIncome: 0.0225,
    CoContributionLowerThreshold: 45400,
    CoContributionUpperThreshold: 60400,
    MaximumContributionBase: 1000,
    CurrentMaximumCoContribution: 500,
    SGCMaximumContributionBase: 65070,
    UntaxedPlanCapAmount: 1780000,
    ConcessionalContributionThreshold: 30793,
    NonConcessionalContributionThreshold: 123172,
    PensionTransferBalanceCap: 1989502,
    LowIncomeEarnersGovernmentContributionIncomeThreshold: 37000,
    LowIncomeEarnersGovernmentContributionMaximum: 500,
    HighIncomeEarningThreshold: 250000,
    WorkBonus: 300,
    IncomeTaxRates_2024: {
        band_0: {
            bandStart: 0,
            rate: 0
        },
        band_1: {
            bandStart: 18200,
            rate: 0.16
        },
        band_2: {
            bandStart: 45000,
            rate: 0.3
        },
        band_3: {
            bandStart: 135000,
            rate: 0.37
        },
        band_4: {
            bandStart: 190000,
            rate: 0.45
        }
    },
    MedicareLowerThreshold: 24276,
    MedicareUpperThreshold: 30345,
    MedicarePhasingInRate: 0.1,
    MedicareRate: 0.02,
    LITO_2022_LowIncomeThreshold: 37500,
    LITO_2022_MiddleIncomeThreshold: 45000,
    LITO_2022_HighIncomeThreshold: 66667,
    LITO_2022_MaxPaymentRate: 700,
    LITO_2022_LowPaymentRate: 325,
    LITO_2022_InitialPhaseOutRate: 0.05,
    LITO_2022_SubsequentPhaseOutRate: 0.015,
    MaximumSATO: 2230,
    MaximumSATOCouple: 1602,
    SATOLowerThreshold: 32279,
    SATOLowerThresholdCouple: 28974,
    SATOUpperThreshold: 50119,
    SATOUpperThresholdCouple: 41790,
    UntaxedComponent: 0,
    UntaxedComponent_2: 0,
    AgeNowCompletedPartYear: 0,
    AgeNowCompletedPartYear_2: 0,
    EnforceMaximumContributionBase: 0,
    IncludeCoContributions: 0,
    QSuperDefaultInsuranceUnitsGovernment: 2,
    QSuperDefaultInsuranceUnitsNonGovernment: 2,
    FSSInsurancePremium: 242,
    InsurancePremium: 100,
    EquipInsurancePremium: -1,
    VisionTPD: 223.85,
    ActiveSuper_MaleDeathPerUnitPerMonth: 0.854,
    ActiveSuper_FemaleDeathPerUnitPerMonth: 0.658,
    ActiveSuper_MaleTPDPerUnitPerMonth: 0.444,
    ActiveSuper_FemaleTPDPerUnitPerMonth: 0.553,
    ActiveSuperInsuranceInflation: 0.005,
    SeniorSupplementSingle: 858.0,
    SeniorSupplementCouple: 647.4,
    SeniorSupplementIncomeThresholdSingle: 50000,
    SeniorSupplementIncomeThresholdCouple: 80000,
    Legacy603CalculationMethod: false,
    VisionIPSalaryThreshold: 0,
    VisionIncomeProtection: {
        startAge: 16,
        cost: [
            0.2,
            0.2,
            0.2,
            0.2,
            0.22,
            0.22,
            0.22,
            0.22,
            0.22,
            0.24,
            0.24,
            0.24,
            0.24,
            0.24,
            0.25,
            0.25,
            0.25,
            0.25,
            0.25,
            0.33,
            0.33,
            0.33,
            0.33,
            0.33,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.82,
            0.82,
            0.82,
            0.82,
            0.82,
            1.15,
            1.15,
            1.15,
            1.15,
            1.15,
            1.8,
            1.8,
            1.8,
            1.8,
            1.8,
            1.82,
            1.82,
            1.82,
            1.82,
            1.82,
            1.82
        ]
    },
    Output: true,
    Testing: false,
    Debug: false,
    CalculationDate: "30/06/2022",
    IncludePartner: false,
    IncludeAgePension: true,
    IncludeTTR: false,
    PriceInflationIndex: [0.04],
    WageInflationIndex: [0.04],
    SunSuperTargetIncomeInflationInRetirement: 0.03,
    AgePensionAllowCouplePensions: false,
    HomeOwner: false,
    Married: false,
    OtherAssets: 0,
    OtherIncome: 0,
    EnforceMinimumDrawingRequirements: false,
    AccountType: 1,
    AccruedDBMultiple: 0,
    AccumulationMemberCoreContributionRate: 0,
    AgeNow: 35,
    DBMemberCoreContributionRate: 0,
    UseSpecificDBAccrualRates: false,
    DeferredRetirementBalance: 0,
    EmployerContributionRate: 0.115,
    InitialExternalPension: 0,
    InvestmentOption: 3,
    InvestmentOptionInRetirement: 3,
    MemberType: 0,
    OneOffContribution: 0,
    OneOffContributionMadeAtAge: 35,
    PartTimeWorkDaysPerWeek: 0,
    PartTimeWorkFromAge: 35,
    PartTimeWorkYearsDuration: 0,
    PostTaxContributions: true,
    PostTaxMemberContributions: 0,
    PreTaxMemberContributions: 0,
    RetirementAge: 65,
    RollOverAmount: 0,
    RollOverAge: 0,
    Salary: 50000,
    Sex: "Male",
    SuperannuationBalance: 0,
    WithdrawalAtRetirement: 0,
    FutureYearsCurrentEmployment: 0,
    ContributionRateSubsequentEmployment: 0,
    AccountType_2: 1,
    AccruedDBMultiple_2: 0,
    AccumulationMemberCoreContributionRate_2: 0,
    AgeNow_2: 35,
    DBMemberCoreContributionRate_2: 0,
    UseSpecificDBAccrualRates_2: false,
    DeferredRetirementBalance_2: 0,
    EmployerContributionRate_2: 0.115,
    InitialExternalPension_2: 0,
    InvestmentOption_2: 3,
    InvestmentOptionInRetirement_2: 3,
    MemberType_2: 0,
    OneOffContribution_2: 0,
    OneOffContributionMadeAtAge_2: 0,
    PartTimeWorkDaysPerWeek_2: 0,
    PartTimeWorkFromAge_2: 0,
    PartTimeWorkYearsDuration_2: 0,
    PostTaxContributions_2: true,
    PostTaxMemberContributions_2: 0,
    PreTaxMemberContributions_2: 0,
    RetirementAge_2: 65,
    RollOverAmount_2: 0,
    RollOverAge_2: 0,
    Salary_2: 10000,
    Sex_2: "Male",
    SuperannuationBalance_2: 0,
    WithdrawalAtRetirement_2: 0,
    FutureYearsCurrentEmployment_2: 0,
    ContributionRateSubsequentEmployment_2: 0,
    AbsLifeTable: {
        startAge: 0,
        male: [
            83.70,
            82.95,
            81.96,
            80.97,
            79.98,
            78.98,
            77.98,
            76.98,
            75.98,
            74.98,
            73.98,
            72.98,
            71.98,
            70.98,
            69.98,
            68.98,
            67.98,
            66.99,
            66.01,
            65.02,
            64.04,
            63.06,
            62.08,
            61.09,
            60.11,
            59.13,
            58.15,
            57.16,
            56.18,
            55.20,
            54.21,
            53.23,
            52.25,
            51.27,
            50.29,
            49.31,
            48.33,
            47.35,
            46.37,
            45.39,
            44.41,
            43.43,
            42.45,
            41.48,
            40.51,
            39.55,
            38.59,
            37.63,
            36.67,
            35.72,
            34.76,
            33.81,
            32.86,
            31.93,
            31.00,
            30.07,
            29.14,
            28.23,
            27.32,
            26.42,
            25.52,
            24.64,
            23.75,
            22.87,
            22.00,
            21.15,
            20.30,
            19.45,
            18.62,
            17.80,
            16.99,
            16.19,
            15.39,
            14.60,
            13.82,
            13.05,
            12.31,
            11.58,
            10.88,
            10.20,
            9.55,
            8.92,
            8.32,
            7.74,
            7.19,
            6.66,
            6.15,
            5.68,
            5.25,
            4.85,
            4.43,
            4.11,
            3.82,
            3.54,
            3.30,
            3.11,
            2.94,
            2.76,
            2.60,
            2.49,
            2.42
        ],
        female: [
            86.72,
            85.96,
            84.98,
            83.99,
            82.99,
            82.00,
            81.00,
            80.01,
            79.01,
            78.01,
            77.02,
            76.02,
            75.02,
            74.03,
            73.03,
            72.04,
            71.04,
            70.05,
            69.05,
            68.06,
            67.07,
            66.07,
            65.08,
            64.09,
            63.10,
            62.12,
            61.12,
            60.13,
            59.14,
            58.15,
            57.16,
            56.16,
            55.17,
            54.18,
            53.18,
            52.19,
            51.20,
            50.22,
            49.24,
            48.25,
            47.27,
            46.28,
            45.30,
            44.32,
            43.35,
            42.37,
            41.40,
            40.43,
            39.46,
            38.50,
            37.53,
            36.57,
            35.61,
            34.66,
            33.70,
            32.75,
            31.80,
            30.86,
            29.92,
            28.99,
            28.06,
            27.13,
            26.21,
            25.29,
            24.37,
            23.47,
            22.56,
            21.66,
            20.77,
            19.89,
            19.02,
            18.15,
            17.30,
            16.45,
            15.61,
            14.80,
            13.98,
            13.19,
            12.42,
            11.66,
            10.93,
            10.22,
            9.53,
            8.86,
            8.23,
            7.62,
            7.04,
            6.49,
            5.97,
            5.49,
            5.04,
            4.64,
            4.27,
            3.92,
            3.62,
            3.35,
            3.14,
            2.94,
            2.77,
            2.68,
            2.70
        ],
        all: [
            85.21,
            84.46,
            83.47,
            82.48,
            81.48,
            80.49,
            79.49,
            78.50,
            77.50,
            76.50,
            75.50,
            74.50,
            73.50,
            72.50,
            71.50,
            70.51,
            69.51,
            68.52,
            67.53,
            66.54,
            65.55,
            64.57,
            63.58,
            62.59,
            61.61,
            60.62,
            59.64,
            58.65,
            57.66,
            56.67,
            55.69,
            54.70,
            53.71,
            52.72,
            51.74,
            50.75,
            49.77,
            48.79,
            47.80,
            46.82,
            45.84,
            44.86,
            43.88,
            42.90,
            41.93,
            40.96,
            39.99,
            39.03,
            38.07,
            37.11,
            36.15,
            35.19,
            34.24,
            33.29,
            32.35,
            31.41,
            30.47,
            29.54,
            28.62,
            27.70,
            26.79,
            25.88,
            24.98,
            24.08,
            23.19,
            22.31,
            21.43,
            20.56,
            19.69,
            18.85,
            18.00,
            17.17,
            16.35,
            15.53,
            14.72,
            13.92,
            13.14,
            12.39,
            11.65,
            10.93,
            10.24,
            9.57,
            8.92,
            8.30,
            7.71,
            7.14,
            6.60,
            6.08,
            5.61,
            5.17,
            4.73,
            4.37,
            4.05,
            3.73,
            3.46,
            3.23,
            3.04,
            2.85,
            2.69,
            2.58,
            2.56
        ]
    },
    AlternateLifeTable: {
        startAge: 50,
        male: [
            31.43,
            30.53,
            29.63,
            28.73,
            27.84,
            26.95,
            26.08,
            25.2,
            24.34,
            23.48,
            22.63,
            21.79,
            20.96,
            20.14,
            19.34,
            18.54,
            17.76,
            16.99,
            16.24,
            15.49,
            14.76,
            14.04,
            13.33,
            12.64,
            11.96,
            11.31,
            10.68,
            10.07,
            9.48,
            8.92,
            8.38,
            7.86,
            7.36,
            6.89,
            6.45,
            6.03,
            5.64,
            5.27,
            4.94,
            4.63,
            4.36,
            4.11,
            3.89,
            3.69,
            3.51,
            3.36,
            3.22,
            3.1,
            2.99,
            2.9
        ],
        female: [
            35.17,
            34.24,
            33.31,
            32.38,
            31.45,
            30.53,
            29.61,
            28.7,
            27.79,
            26.89,
            26,
            25.11,
            24.23,
            23.35,
            22.48,
            21.62,
            20.76,
            19.92,
            19.08,
            18.24,
            17.42,
            16.61,
            15.82,
            15.03,
            14.27,
            13.51,
            12.78,
            12.05,
            11.35,
            10.67,
            10.01,
            9.37,
            8.75,
            8.17,
            7.61,
            7.08,
            6.58,
            6.11,
            5.68,
            5.28,
            4.91,
            4.57,
            4.27,
            3.99,
            3.75,
            3.53,
            3.33,
            3.16,
            3,
            2.86
        ]
    },
    SunSuper_50: {
        startAge: 55,
        male: [
            32,
            31,
            30,
            29,
            28,
            27,
            26,
            25,
            24,
            23,
            22,
            21,
            20,
            19,
            18,
            17,
            16,
            15,
            14,
            13,
            13
        ],
        female: [
            35,
            34,
            33,
            32,
            31,
            30,
            29,
            28,
            27,
            26,
            24,
            23,
            22,
            21,
            20,
            19,
            18,
            17,
            16,
            15,
            14
        ]
    },
    SunSuper_10: {
        startAge: 55,
        male: [
            42,
            41,
            40,
            39,
            38,
            37,
            36,
            35,
            34,
            33,
            32,
            31,
            30,
            29,
            28,
            27,
            26,
            25,
            24,
            23,
            22
        ],
        female: [
            44,
            43,
            42,
            41,
            40,
            39,
            38,
            37,
            36,
            34,
            33,
            32,
            31,
            30,
            29,
            28,
            27,
            26,
            25,
            24,
            23
        ]
    },
    EmployerAccrualTable: {
        rate_1: {
            contributionRate: 0.0,
            memberType: "qsuper",
            accrualRate: 0.0
        },
        rate_2: {
            contributionRate: 0.01,
            memberType: "qsuper",
            accrualRate: 0.0
        },
        rate_3: {
            contributionRate: 0.02,
            memberType: "qsuper",
            accrualRate: 0.135
        },
        rate_4: {
            contributionRate: 0.03,
            memberType: "qsuper",
            accrualRate: 0.16
        },
        rate_5: {
            contributionRate: 0.04,
            memberType: "qsuper",
            accrualRate: 0.185
        },
        rate_6: {
            contributionRate: 0.05,
            memberType: "qsuper",
            accrualRate: 0.21
        },
        rate_7: {
            contributionRate: 0.0,
            memberType: "qpolice",
            accrualRate: 0.0
        },
        rate_8: {
            contributionRate: 0.01,
            memberType: "qpolice",
            accrualRate: 0.0
        },
        rate_9: {
            contributionRate: 0.02,
            memberType: "qpolice",
            accrualRate: 0.0
        },
        rate_10: {
            contributionRate: 0.03,
            memberType: "qpolice",
            accrualRate: 0.14
        },
        rate_11: {
            contributionRate: 0.04,
            memberType: "qpolice",
            accrualRate: 0.175
        },
        rate_12: {
            contributionRate: 0.05,
            memberType: "qpolice",
            accrualRate: 0.21
        },
        rate_13: {
            contributionRate: 0.06,
            memberType: "qpolice",
            accrualRate: 0.245
        },
        rate_14: {
            contributionRate: 0.0,
            memberType: "AGEST",
            accrualRate: 0.0
        },
        rate_15: {
            contributionRate: 0.01,
            memberType: "AGEST",
            accrualRate: 0.0
        },
        rate_16: {
            contributionRate: 0.02,
            memberType: "AGEST",
            accrualRate: 0.0
        },
        rate_17: {
            contributionRate: 0.03,
            memberType: "AGEST",
            accrualRate: 0.0
        },
        rate_18: {
            contributionRate: 0.04,
            memberType: "AGEST",
            accrualRate: 0.0
        },
        rate_19: {
            contributionRate: 0.05,
            memberType: "AGEST",
            accrualRate: 0.0
        },
        rate_20: {
            contributionRate: 0.06,
            memberType: "AGEST",
            accrualRate: 0.0
        },
        rate_21: {
            contributionRate: 0.07,
            memberType: "AGEST",
            accrualRate: 0.0
        },
        rate_22: {
            contributionRate: 0.08,
            memberType: "AGEST",
            accrualRate: 0.0
        },
        rate_23: {
            contributionRate: 0.09,
            memberType: "AGEST",
            accrualRate: 0.0
        },
        rate_24: {
            contributionRate: 0.1,
            memberType: "AGEST",
            accrualRate: 0.0
        }
    },
    EmployerContributionTable: {
        rate_1: {
            contributionRate: 0.0,
            memberType: "qsuper",
            accumulationContributionRate: 0.09
        },
        rate_2: {
            contributionRate: 0.01,
            memberType: "qsuper",
            accumulationContributionRate: 0.0
        },
        rate_3: {
            contributionRate: 0.02,
            memberType: "qsuper",
            accumulationContributionRate: 0.0975
        },
        rate_4: {
            contributionRate: 0.03,
            memberType: "qsuper",
            accumulationContributionRate: 0.1075
        },
        rate_5: {
            contributionRate: 0.04,
            memberType: "qsuper",
            accumulationContributionRate: 0.1175
        },
        rate_6: {
            contributionRate: 0.05,
            memberType: "qsuper",
            accumulationContributionRate: 0.1275
        },
        rate_7: {
            contributionRate: 0.0,
            memberType: "qpolice",
            accumulationContributionRate: 0.09
        },
        rate_8: {
            contributionRate: 0.01,
            memberType: "qpolice",
            accumulationContributionRate: 0.0
        },
        rate_9: {
            contributionRate: 0.02,
            memberType: "qpolice",
            accumulationContributionRate: 0.0
        },
        rate_10: {
            contributionRate: 0.03,
            memberType: "qpolice",
            accumulationContributionRate: 0.12
        },
        rate_11: {
            contributionRate: 0.04,
            memberType: "qpolice",
            accumulationContributionRate: 0.14
        },
        rate_12: {
            contributionRate: 0.05,
            memberType: "qpolice",
            accumulationContributionRate: 0.16
        },
        rate_13: {
            contributionRate: 0.06,
            memberType: "qpolice",
            accumulationContributionRate: 0.18
        }
    },
    GovernmentIncomeProtectionTable: {
        startAge: 16,
        cost: [
            0.00311,
            0.00312,
            0.00317,
            0.00325,
            0.00338,
            0.00346,
            0.00363,
            0.00388,
            0.00412,
            0.00441,
            0.00466,
            0.00494,
            0.00525,
            0.00552,
            0.00579,
            0.00625,
            0.00666,
            0.00719,
            0.00776,
            0.00836,
            0.00884,
            0.00944,
            0.01001,
            0.01051,
            0.01090,
            0.01147,
            0.01184,
            0.01218,
            0.01251,
            0.01291,
            0.01334,
            0.01373,
            0.01402,
            0.01457,
            0.01509,
            0.01576,
            0.01653,
            0.01752,
            0.01827,
            0.01933,
            0.02039,
            0.02177,
            0.02308,
            0.02501,
            0.02665,
            0.02912,
            0.03087,
            0.03056,
            0.01674,
            0
        ]
    },
    PoliceIncomeProtectionTable: {
        startAge: 16,
        cost: [
            0.00079,
            0.00080,
            0.00081,
            0.00083,
            0.00087,
            0.00088,
            0.00092,
            0.00096,
            0.00099,
            0.00104,
            0.00110,
            0.00114,
            0.00121,
            0.00129,
            0.00132,
            0.00143,
            0.00155,
            0.00166,
            0.00179,
            0.00190,
            0.00202,
            0.00212,
            0.00224,
            0.00234,
            0.00246,
            0.00255,
            0.00267,
            0.00280,
            0.00294,
            0.00306,
            0.00325,
            0.00340,
            0.00351,
            0.00364,
            0.00379,
            0.00402,
            0.00421,
            0.00446,
            0.00477,
            0.00506,
            0.00530,
            0.00571,
            0.00433,
            0.00057,
            0
        ]
    },
    NonGovernmentIncomeProtectionTable: {
        startAge: 16,
        cost: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]
    },
    SunSuperDeathTPDMale: {
        startAge: 15,
        cost: [
            2.0,
            2.0,
            2.0,
            2.0,
            2.0,
            2.0,
            2.0,
            3.52,
            3.52,
            3.52,
            3.52,
            3.52,
            3.52,
            3.52,
            3.52,
            6.4,
            6.4,
            6.4,
            6.4,
            6.4,
            6.4,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            7.56,
            3.96,
            3.96,
            3.96
        ]
    },
    SunSuperDeathTPDFemale: {
        startAge: 15,
        cost: [
            1.2,
            1.2,
            1.2,
            1.2,
            1.2,
            1.2,
            1.2,
            2.36,
            2.36,
            2.36,
            2.36,
            2.36,
            2.36,
            2.36,
            2.36,
            4.32,
            4.32,
            4.32,
            4.32,
            4.32,
            4.32,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            5.92,
            2.56,
            2.56,
            2.56
        ]
    },
    QSuperDeathTPDDefault: {
        startAge: 16,
        cost: [
            0.60,
            0.61,
            0.61,
            0.63,
            0.66,
            0.71,
            0.80,
            0.94,
            1.10,
            1.30,
            1.50,
            1.76,
            2.05,
            2.35,
            2.65,
            2.95,
            3.24,
            3.55,
            3.86,
            4.22,
            4.58,
            4.99,
            5.43,
            5.84,
            6.24,
            6.42,
            6.43,
            6.44,
            6.44,
            6.44,
            6.44,
            6.44,
            6.44,
            6.44,
            6.31,
            6.07,
            5.82,
            5.56,
            5.33,
            5.07,
            4.72,
            4.28,
            3.78,
            3.35,
            2.96,
            2.61,
            2.39,
            2.32,
            2.23,
            0.66,
            0.72,
            0.78,
            0.85,
            0.92
        ]
    },
    QSuperDeathTPDPolice: {
        startAge: 16,
        cost: [
            0.73,
            0.74,
            0.74,
            0.77,
            0.81,
            0.89,
            1.02,
            1.20,
            1.43,
            1.71,
            2.01,
            2.39,
            2.80,
            3.24,
            3.69,
            4.12,
            4.57,
            5.02,
            5.48,
            6.00,
            6.52,
            7.12,
            7.76,
            8.36,
            8.95,
            9.22,
            9.24,
            9.25,
            9.26,
            9.26,
            9.27,
            9.28,
            9.27,
            9.27,
            9.07,
            8.74,
            8.37,
            7.99,
            7.66,
            7.28,
            6.78,
            6.14,
            5.42,
            4.80,
            0,
            0
        ]
    },
    InTodaysTerms: true,
    EquipDeathPremiums: {
        startAge: 0,
        cost: []
    },
    EquipTPDPremiums: {
        startAge: 0,
        cost: []
    },
    EquipDeathCoverTaper: {
        startAge: 0,
        cost: []
    },
    EquipTPDCoverTaper: {
        startAge: 0,
        cost: []
    },
    EquipInsurancePremiumSteps: {
        startAge: 0,
        cost: []
    }
};
//# sourceMappingURL=defaults.js.map